module CheckableDateBox {
	export function construct() {
		$(".checkable-date-box button").click(toggle);
	}

	function toggle(): void {
		const element = $(this);
		const parent = getParent(element);
		const input = getInput(element);
		const newValue = getNewValue(input);
		input.val(newValue);
		input.change();//Not sure if needed.
		updateGraphics(parent, newValue);
	}

	function updateGraphics(parent: JQuery<HTMLElement>, newValue: string): void {
		var uncheckInputGroup = parent.find(".input-group").eq(0);
		var checkButton = uncheckInputGroup.next();
		if (newValue === "") {
			uncheckInputGroup.hide();
			checkButton.show();
		}
		else {
			uncheckInputGroup.show();
			checkButton.hide();
		}
	}

	function getNewValue(input: JQuery<HTMLElement>): string {
		if (input.val() === "") {
			const inputType = input.prop("type");
			if (inputType == "date") {
				return getCurrentDateString();
			} else if (inputType == "datetime-local") {
				return getCurrentDateTimeInputString();
			}
			console.error(`Invalid input type ${inputType}.`);
		}
		else {
			return "";
		}
	}

	function getInput(element: JQuery<HTMLElement>): JQuery<HTMLElement> {
		return element.parents(".checkable-date-box").find("input").eq(0);
	}

	function getCurrentDateString(): string {
		return moment().format("YYYY-MM-DD");
	}

	function getCurrentTimeString(): string {
		return moment().format("HH:mm:ss");
	}

	function getCurrentDateTimeInputString(): string {
		return getCurrentDateString() + "T" + getCurrentTimeString();
	}

	function getParent(element: JQuery<HTMLElement>): JQuery<HTMLElement> {
		return element.parents(".checkable-date-box");
	}
}